
import { Component, Mixins, Watch } from "vue-property-decorator";
import { default as ModalPresentableMixin } from "./ModalPresentableMixin.vue";
import { default as DialogTransparentComponent } from "../dialogs/DialogTransparentComponent.vue";
import { BrowserUtility, BrowserKinds } from "../../../utilities";

@Component({
  components: {
    DialogTransparentComponent,
  }
})
export default class DialogMixin extends Mixins(ModalPresentableMixin) {
  data(): any {
    return {
      isVisible: false,
      isTransparent: false,
    };
  }
  isVisible: boolean;
  isTransparent: boolean;

  get dialogClass() {
    return this.isTransparent
      ? "is-transparent"
      : null;
  }

  async showModal<T>(process: () => Promise<T>): Promise<T> {
    if (this.isVisible) {
      throw new Error("dialog is already displayed.");
    }
    try {
      this.beginModal();
      this.isVisible = true;
      const result = await process();
      return result;
    } finally {
      this.endModal();
    }
  }

  async waitHidden(shouldFixedRootStyle: boolean = false): Promise<void> {
    if (shouldFixedRootStyle && BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer) {
      this.setFixedRootStyle();
      await this.$wait(() => !this.isVisible);
      this.removeFixedRootStyle();
    } else {
      await this.$wait(() => !this.isVisible);
    }
  }

  @Watch("isTransparent")
  onIsTransparentUpdated(newValue: boolean, oldValue: boolean): void {
    if (this.isVisible) {
      this.updateModal(newValue);
    }
  }

  private setFixedRootStyle(): void {
    // IEで行選択ハイライトが正しく表示できない問題への対策
    // 呼び元の画面を非表示にするとにより正しく表示できるようになったが、他のダイアログでも発生してもおかしくないが発生せず
    // スクロールバーの表示状態で発生の有無が変わるようだが正しくは特定できず
    // 別の方法を模索しダイアログで生成されるDOMにあるel-dialog__wrapperクラスのoverflowをhiddenにすることでも正しく表示できるようになった
    // forked-libs内に定義しているCSSを修正することも検討できるが、影響を考えて個別に対応する
    // el-dialog__wrapperではstyleをコンポーネントが書き換えているため設定の仕方に注意が必要(setAttribute()を使うとダイアログが正しく動作しなくなる)
    this.$nextTick(() => {
      const element = this.getFixedRootElement();
      element.style.overflow = "hidden";
    });
  }

  private removeFixedRootStyle(): void {
    // IEで行選択ハイライトが正しく表示できない問題への対策
    const element = this.getFixedRootElement();
    element.style.overflow = "";
  }

  private getFixedRootElement(element: HTMLElement = this.$el as HTMLElement): HTMLElement {
    return (element === null || element.className.search("el-dialog__wrapper") > -1)
      ? element
      : this.getFixedRootElement(element.parentElement);
  }
}
